// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__28pbf","content":"styles_content__3Zu5S","checkbox":"styles_checkbox__26aBh","checkboxLabel":"styles_checkboxLabel__3GPgB"};